{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-20T14:11:23.361Z","source":"place-details"}